import { IconMango } from 'icons/components/IconMango'

import { cx } from 'utils/cx'
import styles from './AvatarMessage.module.scss'

interface AvatarMessagePropsAI {
	readonly avatar: 'ai'
	readonly character?: null
}

interface AvatarMessagePropsHuman {
	readonly avatar: 'human'
	readonly character: string
}

export function AvatarMessage({
	avatar,
	character,
}: AvatarMessagePropsAI | AvatarMessagePropsHuman) {
	const avatarContent = {
		ai: <IconMango width={10} height={10} color='content-inverse' />,
		human: character,
	}

	return (
		<div className={styles.avatarContainer}>
			<div className={cx(styles.avatarMessage, character && styles.character)}>
				{avatarContent[avatar]}
			</div>
		</div>
	)
}
